export default __webpack_public_path__ + "static/media/html.4dfa5133.svg";